module.exports = __webpack_public_path__ + "img/process4.99c7c777.png";